import Vue from 'vue'
import 'normalize.css/normalize.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: () => import('../views/login/login.vue') },
  {
    path: '/home', redirect: '/welcome', component: () => import('../views/login/home.vue'),
    children: [
      { path: '/welcome', component: () => import('../views/login/welcome.vue') },

      { path: '/user/student', component: () => import('../views/user/student.vue') },
      { path: '/user/parent', component: () => import('../views/user/parent.vue') },
      { path: '/user/parentLoginLog', component: () => import('../views/user/parentLoginLog.vue') },

      { path: '/school/list', component: () => import('../views/school/list.vue') },
      { path: '/school/notice', component: () => import('../views/school/notice.vue') },
      { path: '/school/notice_detail', component: () => import('../views/school/notice_detail.vue') },

      { path: '/ad/conf', component: () => import('../views/ad/adSet.vue') },

      { path: '/task/wxConf', component: () => import('../views/task/wxConf.vue') },
      { path: '/task/dyConf', component: () => import('../views/task/dyConf.vue') },
      { path: '/task/log', component: () => import('../views/task/log.vue') },
      { path: '/task/txLog', component: () => import('../views/task/txLog.vue') },
      { path: '/task/moneyConf', component: () => import('../views/task/moneyConf.vue') },
      { path: '/task/kidsConf', component: () => import('../views/task/kidsConf.vue') },

      { path: '/phone/cz', component: () => import('../views/phone/cz.vue') },
      { path: '/phone/activity', component: () => import('../views/phone/activity.vue') },
      { path: '/phone/studentCallLog', component: () => import('../views/phone/studentCallLog.vue') },
      { path: '/phone/useLog', component: () => import('../views/phone/useLog.vue') },


  ]

  },
  
]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {

  NProgress.start();
  if (to.path === '/login') {
    next();
    NProgress.done()
  } else {
    const tokenStr = window.sessionStorage.getItem("game-token");
    if (!tokenStr) {
      next('/login')
      NProgress.done()
    } else {
      next()
      NProgress.done()

    }
  }



})
router.afterEach(() => {
  NProgress.done()
});

export default router
